<template>
  <app-shell breadcrumbs="Documentation">
    <div class="row">
      <div class="col">
        <iframe style="width: 100%; height: 99vh; align-content: center; text-align: center" src="https://tingg.gitbook.io/checkout/"></iframe>
      </div>
    </div>
  </app-shell>
</template>

<script>
  import Shell from '@/components/Shell'

  export default {
    components: {
      'app-shell': Shell
    },
    name: 'Documentation'
  }
</script>

<style lang="scss">
  ::-webkit-scrollbar {
      display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/Documentation.vue